import { z } from 'zod';
// Zod schemas for validation
/**
 * Custom Zod schema for Timestamp validation
 */
const TimestampSchema = z.object({
    seconds: z.number(),
    nanoseconds: z.number(),
    toDate: z.function(),
    toMillis: z.function(),
});
/**
 * Schema for validating assignment status
 */
export const AssignmentStatusSchema = z.enum(['assigned', 'in_progress', 'completed', 'needs_revision', 'approved']);
/**
 * Schema for validating complete workflow assignment data
 */
export const WorkflowAssignmentSchema = z.object({
    id: z.string().min(1),
    cycleId: z.string().min(1),
    workflowId: z.string().min(1),
    workflowName: z.string().min(1),
    assignedTo: z.string().min(1),
    assignedBy: z.string().min(1),
    status: AssignmentStatusSchema,
    dueDate: TimestampSchema,
    submittedAt: TimestampSchema.optional(),
    approvedAt: TimestampSchema.optional(),
    approvedBy: z.string().min(1).optional(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
/**
 * Schema for validating assignment creation data
 */
export const CreateAssignmentDataSchema = z.object({
    cycleId: z.string().min(1),
    workflowId: z.string().min(1),
    workflowName: z.string().min(1),
    assignedTo: z.string().min(1),
    assignedBy: z.string().min(1),
    dueDate: TimestampSchema,
});
/**
 * Schema for validating assignment update data
 */
export const UpdateAssignmentDataSchema = z.object({
    status: AssignmentStatusSchema.optional(),
    dueDate: TimestampSchema.optional(),
    submittedAt: TimestampSchema.optional(),
    approvedAt: TimestampSchema.optional(),
    approvedBy: z.string().min(1).optional(),
});
/**
 * Schema for validating assignment summary data
 */
export const AssignmentSummarySchema = z.object({
    id: z.string().min(1),
    workflowName: z.string().min(1),
    status: AssignmentStatusSchema,
    dueDate: TimestampSchema,
    assignedToName: z.string().min(1),
    daysUntilDue: z.number(),
});
/**
 * Type guards for assignment data
 */
export const isValidWorkflowAssignment = (data) => {
    return WorkflowAssignmentSchema.safeParse(data).success;
};
export const isValidAssignmentStatus = (status) => {
    return AssignmentStatusSchema.safeParse(status).success;
};
export const isValidCreateAssignmentData = (data) => {
    return CreateAssignmentDataSchema.safeParse(data).success;
};
export const isValidUpdateAssignmentData = (data) => {
    return UpdateAssignmentDataSchema.safeParse(data).success;
};
export const isValidAssignmentSummary = (data) => {
    return AssignmentSummarySchema.safeParse(data).success;
};
